<template>
  <div class="interior-designer-form">
    <applications-interior-designer-header></applications-interior-designer-header>
    <applications-interior-designer-steps></applications-interior-designer-steps>
  </div>
</template>

<script>
import ApplicationsInteriorDesignerHeader from './header';
import ApplicationsInteriorDesignerSteps from './steps/';

export default {
  name: 'ApplicationsInteriorDesigner',
  components: {
    ApplicationsInteriorDesignerHeader,
    ApplicationsInteriorDesignerSteps,
  },
};
</script>
